import { fetchQuery, graphql } from "relay-runtime"
import {
  GetAvailableSlotsCapacityInput,
  useAvailableSlotsCapacityQuery,
} from "@/modules/patients/services/__generated__/useAvailableSlotsCapacityQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const availableSlotsCapacity = graphql`
  query useAvailableSlotsCapacityQuery($input: GetAvailableSlotsCapacityInput!) {
    availableSlotsCapacity(filter: $input) {
      ... on SuccessSlotCapacityResult {
        isSuccess
        result {
          slotId
          date
          isAvailable
          allowPriorityBooking
        }
      }
      ... on ErrorSlotCapacityResult {
        error {
          message
        }
        isSuccess
      }
    }
  }
`

export const fetchAvailableSlotsCapacityQuery = (input: GetAvailableSlotsCapacityInput, signal: AbortSignal) => {
  return fetchQuery<useAvailableSlotsCapacityQuery>(
    RelayEnvironment,
    availableSlotsCapacity,
    { input },
    { fetchPolicy: "network-only", networkCacheConfig: { metadata: { signal } } },
  ).toPromise()
}
